// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"c5a6370a","131":"84041086","381":"8b2d52b2","385":"51bbdfcc","803":"70e3ba81","864":"ede57e7c","968":"269f4e78"}[chunkId] + ".css";
};